import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, iRootState } from '../redux/store';

const LoadCurrencyPayConfig = function LoadCurrencyPayConfig(): null {
  const dealerId = useSelector((state: iRootState) => state.quote.dealerId);
  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    if (dealerId) {
      dispatch.currencyPay.getConfig(dealerId);
    }
  }, [dispatch.currencyPay, dealerId]);

  return null;
};

export default LoadCurrencyPayConfig;
